import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/settings.actions';

@Injectable()
export class SettingsBarnResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    // (Re)Load when on /settings/barn
    this.store.dispatch(settingActions.loadBarnsRequest());
    this.store.dispatch(settingActions.loadSilosRequest());

    return of(true);
  }
}
